var render = function render(_c,_vm){return _c('div',_vm._b({staticClass:"ez-empty-state",class:_vm.data.staticClass || ''},'div',_vm.data.attrs,false),[_c('div',{staticClass:"ez-empty-state__image"},[_vm._t("badge",function(){return [_c('div',{staticClass:"ez-empty-state__circle"})]})],2),_c('h3',[_vm._t("title")],2),_c('p',[_vm._t("info")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }